"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSLicensePlate = void 0;
function CSLicensePlate(value, options, params) {
    var isValid = true;
    var errors;
    var CSLicensePlateRegex = /[GOQW]+/gi;
    var isRequired = options ? options.condition(params === null || params === void 0 ? void 0 : params.entity) : true;
    return value && value.match(CSLicensePlateRegex) && isRequired
        ? {
            isValid: false,
            errors: {
                value: value,
                constraints: {
                    invalidCSLicensePlate: "false",
                },
            },
        }
        : {
            isValid: isValid,
            errors: errors,
        };
}
exports.CSLicensePlate = CSLicensePlate;
